import { AnalyticsPlugin } from '@pulse/common';
import { DeviceAttributesService } from '../services';

/**
 * Produces default device attributes such as platform, os, and screen_size
 */
export class DeviceAttributesPlugin implements AnalyticsPlugin {
    constructor(private attributeService: DeviceAttributesService) {}

    init() {
        this.attributeService.send();
    }
}
